import { createStyles, makeStyles } from '@material-ui/core/styles';
import { theme } from '../Theme';
import { getHoverShadow } from '../utils/constants';

var createSwitchColor = function (color) {
  return {
    backgroundColor: color + " !important",
    boxShadow: getHoverShadow(color),
    '& .MuiSvgIcon-root': {
      fontSize: "28px !important",
      boxShadow: getHoverShadow('#999999')
    }
  };
};

var useStyles = makeStyles(function () {
  var _theme$colors = theme.colors,
      primaryColor = _theme$colors.primaryColor,
      successColor = _theme$colors.successColor,
      dangerColor = _theme$colors.dangerColor,
      infoColor = _theme$colors.infoColor,
      warningColor = _theme$colors.warningColor,
      grayColor = _theme$colors.grayColor;
  return createStyles({
    "default": createSwitchColor(grayColor),
    primary: createSwitchColor(primaryColor),
    info: createSwitchColor(infoColor),
    success: createSwitchColor(successColor),
    warning: createSwitchColor(warningColor),
    danger: createSwitchColor(dangerColor)
  });
});
export default useStyles;